@if (shippingAddresses) {
  @if (type === 'select') {
    <select [(ngModel)]="shippingAddresses.selected" [disabled]="shippingAddresses.address_access === 'default'"
      name="shippingAddress" class="form-control" (change)="selectShippingAddress($event)">
      @if (showBlank) {
        <option selected [value]="''">{{"MAKE_A_CHOICE"|translate}}</option>
      }
      @for (option of shippingAddresses.shipping_addresses; track option) {
        @if (option.company_group_code === applicationService.getSelectCompanyGroupCode() || showAllCompanies) {
          <option [value]="option.id">
            {{option.name}} ({{option.address}} {{option.zip}} {{option.city}})
          </option>
        }
      }
    </select>
  }
  @if (type === 'dropdown') {
    <div class="d-flex">
      <div class="d-block w-100 pe-0">
        <div ngbDropdown class="d-inline-block w-100 p-e">
          <button type="button" class="w-100 overflow-hidden btn border bg-white text-start" id="dropdownShipping" ngbDropdownToggle  [disabled]="shippingAddresses.address_access === 'default'" >
            @if (selectedAddress && !selectBlank) {
              <strong class="d-block">{{selectedAddress?.name}}</strong>
              {{selectedAddress?.address}} {{selectedAddress?.zip}} {{selectedAddress?.city}}
            }
            @if (!selectedAddress || selectBlank) {
              <strong class="d-block" id="blankOption">{{"MAKE_A_CHOICE"|translate}}</strong>
            }
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownShipping">
            @if (showBlank) {
              <button ngbDropdownItem  selected (click)="shippingAddresses.selected = ''; selectShippingAddress('')">{{"MAKE_A_CHOICE"|translate}}</button>
            }
            @for (option of shippingAddresses.shipping_addresses; track option) {
              @if (option.company_group_code === applicationService.getSelectCompanyGroupCode() || showAllCompanies) {
                <button ngbDropdownItem  (click)="shippingAddresses.selected = option.id; selectShippingAddress(option)"><strong class="d-block">{{option.name}}</strong>{{option.address}} {{option.zip}} {{option.city}}</button>
              }
            }
          </div>
        </div>
      </div>
    </div>
  }
}

